import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  LoadingStage,
  LoadingStatus,
  StageInfo
} from "../../components/Shared/Modals/LoadingStatusModal/LoadingStatusModal";
import type { RootState } from "../store";

export type LoadingState = {
  stages: StageInfo[];
  isModalOpen: boolean;
};

export const initialLoadingState: LoadingState = {
  stages: [
    { stage: "authentication", status: "pending" },
    { stage: "organisation", status: "pending" },
    { stage: "venues", status: "pending" },
    { stage: "venueConfig", status: "pending" }
  ],
  isModalOpen: false
};

type StageUpdate = {
  stage: LoadingStage;
  status: LoadingStatus;
  error?: { message: string; technicalDetails?: string };
};

const loadingSlice = createSlice({
  name: "loading",
  initialState: initialLoadingState,
  reducers: {
    stageUpdated: (state, action: PayloadAction<StageUpdate>) => {
      const { stage, status, error } = action.payload;
      state.stages = state.stages.map((stageInfo) =>
        stageInfo.stage === stage ? { ...stageInfo, status, error } : stageInfo
      );
      if (status === "error") {
        state.isModalOpen = true;
      }
    },
    loadingReset: () => initialLoadingState,
    loadingModalClosed: (state) => {
      state.isModalOpen = false;
    }
  }
});

export const { stageUpdated, loadingReset, loadingModalClosed } =
  loadingSlice.actions;

export const selectLoadingStages = (state: RootState): StageInfo[] =>
  state.loading.stages;
export const selectIsLoadingModalOpen = (state: RootState): boolean =>
  state.loading.isModalOpen;
export const selectIsLoading = (state: RootState): boolean =>
  state.loading.stages.some((stage) => stage.status === "loading");

export const loadingReducer = loadingSlice.reducer;
export default loadingReducer;
